import { mapAddress } from '@general/js/utils/JoinNow';
import { MyCircumstances } from '@general/js/enums';
import mapPolicyHolderPayload from './GetPremiumPrice/PolicyHolder';
import mapPartnerPayload from './GetPremiumPrice/Partner';
import mapChildrenPayload from './GetPremiumPrice/Children';
import mapEligibilityPayload from './GetPremiumPrice/Eligibility';
import { mapRebatePayload, formatMedicareCard } from './ChangeCoverUtils';
import { findPolicyHolder } from './ExtraUtils';
import { getPartnerDetailsMP } from '../MemberUtils';

const getPremiumPricePayload = (
  membershipPolicy,
  memberDetails,
  captureInformationReferenceData,
  changeCoverData,
  caiData,
  convertedCoverType,
  changeCoverEnteredData,
  quoteId,
  hospitalSituations,
) => {
  const productCodesList = changeCoverData.selectedProducts.products.map((product) => {
    return product.productCode;
  });

  const mainPolicyHolder = findPolicyHolder(memberDetails);
  const partner = getPartnerDetailsMP(memberDetails, true);

  // Claims Account
  const claimsAccount = mainPolicyHolder?.claimsAccount;
  claimsAccount.accountType = 'B'; // Must always be a bank account
  claimsAccount.paymentAuthorisation = true;

  const payload = {
    quoteType: 'C',
    quoteId,
    updateCRMQuote: false,
    startDate: changeCoverData.step1.startDate,
    contributionMethod: 'DD',
    frequency: changeCoverData.paymentFrequency.toLowerCase(),
    composition: changeCoverEnteredData.step2.coverComposition,
    state: changeCoverData.step1.state,
    paymentStartDate: changeCoverData.step1.startDate,
    myCircumstances: caiData.rebateInformationStep.myCircumstances ?? MyCircumstances.OTHER,
    addressResidential: mapAddress(caiData.policyHolderStep.residentialAddress, false, false),
    mainPolicyHolder: mapPolicyHolderPayload(mainPolicyHolder, captureInformationReferenceData, changeCoverData, caiData, convertedCoverType, hospitalSituations.policyHolder),
    partner: mapPartnerPayload(partner, captureInformationReferenceData, changeCoverData, caiData, convertedCoverType, hospitalSituations.partner),
    children: mapChildrenPayload(caiData),
    medicareCard: formatMedicareCard(caiData.rebateInformationStep.medicareCard, false),
    productList: [
      {
        productCodes: productCodesList,
        excess: changeCoverData.selectedExcess,
      },
    ],
    premiumPaymentAccount: membershipPolicy.premiumPaymentAccount,
    // claimsAccount, // this isn't required when getting the price on confirmation step
    rebate: mapRebatePayload(caiData.rebateInformationStep.rebateTier),
    termsAndConditionsAcceptance: true,
    MemberNumber: caiData.memberNumber,
    CreationStatus: null,
    eligibility: mapEligibilityPayload(caiData, changeCoverData),
    isRecalculatePremium: true,
  };

  return payload;
};

export default getPremiumPricePayload;
